import isolate from "@cycle/isolate"

import * as R from "ramda"

import { STATE_KEY } from "../../../../constant"

import {
  createCheckInfo,
} from "../../../common"
import { InputCheck, ModificationType} from "../../../../interface"

import { view } from "./view"
import { Confirm, Form } from ".."

const reAny = /./
const recessCheck = (key: string, checkOnRecess: boolean) => (input: any) => {
  const isRecess = R.prop("recess", input) !== "留学・休会を希望しない"

  if ((checkOnRecess && isRecess) || (!(checkOnRecess || isRecess))) {
    return R.length(R.propOr("", key, input)) > 0
  }
    return true
}
const recessTermCheck = (input: any) =>
  R.not(
    R.isEmpty(R.propOr("", "fromYear", input)) ||
    R.isEmpty(R.propOr("", "toYear", input)) ||
    R.isEmpty(R.propOr("", "fromMonth", input)) ||
    R.isEmpty(R.propOr("", "toMonth", input))
  )

const INPUT_CHECKS: InputCheck[] = [
  createCheckInfo("recess", reAny, "申請内容を選択して下さい。"),
  createCheckInfo("fromYear", recessTermCheck, "留学・休会期間を入力してください。"),
  createCheckInfo("rfReason", recessCheck("rfReason", true), "理由を入力してください。"),
  createCheckInfo("contactInfo", recessCheck("contactInfo", true), "連絡先を入力してください。"),
  createCheckInfo("rfCountry", recessCheck("rfCountry", false), "国名を入力してください。"),
  createCheckInfo("rfZip", recessCheck("rfZip", false), "郵便番号を入力してください。"),
  createCheckInfo("rfAddr1", recessCheck("rfAddr1", false), "住所１を入力してください。"),
  createCheckInfo("rfAddr2", recessCheck("rfAddr2", false), "住所２を入力してください。"),
]

export default isolate(Form("recess", STATE_KEY.RecessForm, view, INPUT_CHECKS))

const getReqParam = ([user, form] : [any, any]) => {
  const isNotRecess = R.propEq("留学・休会を希望しない", "recess", form)
  const type = isNotRecess ? ModificationType.Recess2 : ModificationType.Recess
  const memberId = R.prop("id", user)
  const postForm = isNotRecess
    ? R.omit(["rfReason", "contactInfo"], form)
    : R.omit(["rfCountry", "rfZip", "rfAddr1", "rfAddr2", "rfSection"], form)
  return {
    type, memberId, body: postForm,
  }
}

export const RecessConfirm = isolate(Confirm(STATE_KEY.RecessForm, view, getReqParam))
